import { Injectable, inject } from '@angular/core';

import { ActionModel, ConditionModel } from '@models/admin/action.model';

import { UserDateFormatService } from './user-date-format.service';

@Injectable({
  providedIn: 'root',
})
export class CompareService {
  private readonly userDateFormatService = inject(UserDateFormatService);

  checkForRightCondition(action: ActionModel, command: string) {
    if (action.conditions?.length === 0) return false;

    if (action.conditions) {
      for (const compare of action.conditions) {
        if (compare.command == command) return true;
      }
    }

    return false;
  }

  checkForMessageAction(action: ActionModel, command: string) {
    if (action.conditions?.length === 0) return true;

    if (action.conditions) {
      for (const compare of action.conditions) {
        if (compare.command == command) {
          return this.checkForUrlConditions(action.conditions, command);
        }
      }
    }

    return false;
  }

  switchCondition(condition: ConditionModel, cell: any, command: string, type?: string) {
    if (condition && condition.command == command) {
      for (const compare of condition.conditions) {
        if (type && type == 'dateTime') {
          const cellTime = this.toTime(cell);
          const compareTime = this.toTime(compare.key);

          if (cellTime === null || compareTime === null) continue;

          switch (compare.operator) {
            case 'equal':
              if (cellTime === compareTime) return compare.value;
              break;
            case 'notEqual':
              if (cellTime !== compareTime) return compare.value;
              break;
            case 'above':
              if (cellTime > compareTime) return compare.value;
              break;
            case 'below':
              if (cellTime < compareTime) return compare.value;
              break;
            case 'aboveOrEqual':
              if (cellTime >= compareTime) return compare.value;
              break;
            case 'belowOrEqual':
              if (cellTime <= compareTime) return compare.value;
              break;
          }
        } else {
          switch (compare.operator) {
            case 'equal':
              if (cell == compare.key) return compare.value;
              break;
            case 'notEqual':
              if (cell != compare.key) return compare.value;
              break;
          }
        }
      }
    }

    return '';
  }

  checkForActionConditions(action: ActionModel, command: string, row?: any) {
    if (!row) return false;
    const condition = action.conditions.find((condition) => condition.command == command);
    return this.compareRowValues(condition, row);
  }

  checkForRowConditions(conditions: ConditionModel[], command: string, row: any) {
    const condition = conditions.find((condition) => condition.command == command);
    if (!condition) return false;
    return this.compareRowValues(condition, row);
  }

  private compareRowValues(condition: ConditionModel, row: any) {
    const conditionsResult: boolean[] = [];

    for (const compare of condition.conditions) {
      switch (compare.operator) {
        case 'equal':
          conditionsResult.push(row[compare.key] == compare.value);
          break;
        case 'notEqual':
          conditionsResult.push(row[compare.key] != compare.value);
          break;
        case 'above':
          conditionsResult.push(row[compare.key] > compare.value);
          break;
        case 'below':
          conditionsResult.push(row[compare.key] < compare.value);
          break;
        case 'aboveOrEqual':
          conditionsResult.push(row[compare.key] >= compare.value);
          break;
        case 'belowOrEqual':
          conditionsResult.push(row[compare.key] <= compare.value);
          break;
        case 'in':
          conditionsResult.push(row[compare.key].includes(compare.value));
          break;
        case 'notIn':
          conditionsResult.push(!row[compare.key].includes(compare.value));
          break;
      }
    }

    if (condition.combination == 'and') {
      return !conditionsResult.includes(false);
    } else {
      return conditionsResult.includes(true);
    }
  }

  private checkForUrlConditions(conditions: ConditionModel[], command: string) {
    const condition = conditions.find((condition) => condition.command == command);
    if (condition && condition.conditions.length > 0) {
      return this.compareUrlValues(condition);
    }
    return false;
  }

  private compareUrlValues(condition: ConditionModel) {
    const conditionsResult: boolean[] = [];
    const url = location.href;

    for (const compare of condition.conditions) {
      switch (compare.operator) {
        case 'in':
          conditionsResult.push(url.includes(compare.value));
          break;
        case 'notIn':
          conditionsResult.push(url.includes(compare.value));
          break;
      }
    }

    return !conditionsResult.includes(false);
  }

  private toTime(value: any): number | null {
    const parsed = this.userDateFormatService.parse(value);
    return parsed ? parsed.getTime() : null;
  }
}
